function isEnabled(value: string | undefined, defaultValue: boolean): boolean {
  if (value === undefined) {
    return defaultValue;
  }

  return value.toLowerCase() === 'true';
}

export const featureFlags = {
  charterApp: isEnabled(import.meta.env.VITE_FEATURE_CHARTER_APP, false),
  dashboardApp: isEnabled(import.meta.env.VITE_FEATURE_DASHBOARD_APP, false),
};

export type FeatureFlag = keyof typeof featureFlags;

export function isFeatureEnabled(featureFlag: FeatureFlag): boolean {
  return featureFlags[featureFlag];
}
